export default __webpack_public_path__ + "images/4O.49d2f90.png";